import React from 'react'

import { Box, Text, Table } from '@superlogica/design-system'
import Pagination from 'components/Pagination/Pagination'
import { BoxTitleTable, BoxTabTable } from 'styles/global-style'

const View = ({
  isLoading,
  isError,
  tableRebates,
  columns,
  refetch , totalItems, itemsPerPage,setCurrentPage,currentPage, manualSort}) => {

  return (
    <>
      <BoxTabTable
        border
        borderColor="neutral300"
        bgColor="neutral0"
        paddingSize="xs"
        radius="md"
        className="flex align-center"
      >
        <BoxTitleTable paddingSize="none">
          <Text className="mr-xxxs">Rebates</Text>
          <Text color="neutral400" size="body02">
          {`Exibindo ${tableRebates.length}`}
          </Text>
        </BoxTitleTable>
      </BoxTabTable>
      <Box border borderColor="neutral300" bgColor="neutral0" paddingSize="none" radius="xs">
        <Table
          loading={isLoading}
          error={isError}
          data={tableRebates}
          columns={columns}
          tableName="rebates"
          retry={refetch}
          manualSort={manualSort}
        />
      </Box>
      <BoxTabTable
        border
        borderColor="neutral300"
        bgColor="neutral0"
        paddingSize="xxs"
        radius="md"
        className="flex align-center"
      >
      <Pagination
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />
      </BoxTabTable>
    </>
  )
}

export default View
